// custom login popup window name
export const CustomLoginPopupWindowName = 'cmAccessPopup';

// notification id for the msal auth error toast - use a static id to easily dismiss the toast when it becomes irrelevant
export const MsalAuthErrorToastId = 'msal-auth-error-toast-notification';

// error message for sign in timeout (loginRedirect gets stuck on the signin-spa page)
export const SignInTimeout = 'SignInTimeout';

// error message for when the user is authenticated with the wrong account
export const OtherUserAuthenticatedError = 'OtherUserAuthenticatedError';
